<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-brand">
        <img 
          src="@/assets/Zearloops Logo Name.png" 
          alt="Zearloops" 
          class="footer-logo"
        >
      </div>

      <div class="social-icons" aria-label="Social links">
        <a href="https://www.facebook.com/profile.php?id=61550887283226" class="social-icon" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
            <path :d="mdiFacebook" />
          </svg>
        </a>
        <a href="https://x.com/Zearloops" class="social-icon" target="_blank" rel="noopener noreferrer" aria-label="X">
          <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
            <path :d="mdiAlphaX" />
          </svg>
        </a>
        <a href="https://www.instagram.com/zearloops" class="social-icon" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
            <path :d="mdiInstagram" />
          </svg>
        </a>
        <a href="https://discord.gg/ucYRuA2C" class="social-icon" target="_blank" rel="noopener noreferrer" aria-label="Discord">
          <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
            <path :d="mdiGamepadVariant" />
          </svg>
        </a>
      </div>

      <div class="legal-links">
        <router-link to="/terms-of-service" class="legal-link">Terms of Service</router-link>
        <router-link to="/privacy-policy" class="legal-link">Privacy Policy</router-link>
      </div>
    </div>

    <p class="footer-copy">&copy; 2026 Zearloops. All rights reserved.</p>
  </footer>
</template>

<script>
import { mdiAlphaX, mdiFacebook, mdiGamepadVariant, mdiInstagram } from '@mdi/js';

export default {
  name: 'AppFooter',
  data() {
    return {
      mdiAlphaX,
      mdiFacebook,
      mdiGamepadVariant,
      mdiInstagram
    };
  }
};
</script>
